const cardItems = [
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20with%20noir%20detective%20theme%2C%20rainy%20night%20city%2C%20dramatic%20lighting%2C%20warm%20crimson%20and%20gold%20tones%2C%20mysterious%20silhouette%2C%20film%20grain%20texture%2C%20minimal%20design%20with%20negative%20space&width=600&height=800&seq=card-movie-01&orientation=portrait",
    title: '暗夜追踪',
    rating: '8.7',
    tag: '悬疑动作',
    desc: '一名退役警探在雨夜追踪连环案件，层层反转令人窒息',
    year: '2026',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20sci-fi%20theme%2C%20futuristic%20spaceship%20over%20alien%20planet%2C%20warm%20golden%20sunset%20lighting%2C%20dramatic%20composition%2C%20film%20poster%20aesthetic%2C%20epic%20scale%2C%20rich%20warm%20tones&width=600&height=800&seq=card-movie-02&orientation=portrait",
    title: '星际边界',
    rating: '9.1',
    tag: '科幻巨制',
    desc: '人类最后的星际移民船队穿越未知宇宙的史诗旅程',
    year: '2026',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20comedy%20theme%2C%20bright%20warm%20lighting%2C%20playful%20composition%2C%20film%20poster%20aesthetic%2C%20vibrant%20colors%20with%20warm%20amber%20tones%2C%20fun%20and%20energetic%20vibe&width=600&height=800&seq=card-movie-03&orientation=portrait",
    title: '笑林奇遇',
    rating: '8.4',
    tag: '高分喜剧',
    desc: '三个素不相识的陌生人在旅途中碰撞出的爆笑火花',
    year: '2026',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20adventure%20theme%2C%20arctic%20landscape%20with%20explorers%2C%20dramatic%20cold%20and%20warm%20contrast%2C%20film%20poster%20aesthetic%2C%20epic%20survival%20story%2C%20cinematic%20composition&width=600&height=800&seq=card-movie-04&orientation=portrait",
    title: '极地使命',
    rating: '8.9',
    tag: '冒险剧情',
    desc: '科考队在极寒之地发现远古秘密，生死存亡的极限挑战',
    year: '2025',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20romance%20theme%2C%20warm%20golden%20hour%20lighting%2C%20couple%20silhouette%2C%20nostalgic%20atmosphere%2C%20film%20poster%20aesthetic%2C%20dreamy%20soft%20focus%2C%20poetic%20composition&width=600&height=800&seq=card-movie-05&orientation=portrait",
    title: '时光旅人',
    rating: '9.3',
    tag: '爱情科幻',
    desc: '穿越时空只为再见你一面，年度最催泪的浪漫史诗',
    year: '2026',
  },
  {
    img: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20style%20animation%20theme%2C%20magical%20underwater%20world%2C%20warm%20glowing%20colors%2C%20film%20poster%20aesthetic%2C%20whimsical%20and%20enchanting%2C%20rich%20textures%2C%20dreamy%20atmosphere&width=600&height=800&seq=card-movie-06&orientation=portrait",
    title: '深海奇缘',
    rating: '9.0',
    tag: '动画奇幻',
    desc: '一个女孩与海洋生物的奇妙冒险，画面美到每一帧都是壁纸',
    year: '2026',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">本周推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">编辑团队精选的本周最值得观看的高分电影</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cardItems.map((item) => (
            <div key={item.title} className="group rounded-xl overflow-hidden bg-background-100 cursor-pointer hover:bg-background-200 transition-colors">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src={item.img} alt={`${item.title} - ${item.tag}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 bg-black/55 text-accent-400 rounded-md text-xs font-medium">
                  <i className="ri-star-fill text-[10px]"></i>
                  {item.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <span className="text-xs text-white/80">{item.year}</span>
                </div>
              </div>
              <div className="p-3">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-medium text-foreground-900 truncate">{item.title}</h3>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 whitespace-nowrap shrink-0">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}